import { Component, OnInit, OnDestroy, Input } from '@angular/core';

@Component({
    selector: 'app-animated-notification',
    templateUrl: './animated-notification.component.html',
    styleUrls: ['./animated-notification.component.scss'],
    standalone: true
})
export class AnimatedNotificationComponent implements OnInit, OnDestroy {
  message: string;

  constructor() {}

  ngOnInit() {}

  ngOnDestroy() {}
}
